/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import kebabCase from 'lodash/kebabCase';
const dashboardIcons = {
    agents: 'user',
    teams: 'team',
    channels: 'channels',
    tags: 'tag',
    queues: 'users',
};
/**
 * Returns the transformed dashboards response.
 *
 * @param response The raw response from the dashboards endpoint.
 */
export function transformReadDashboardsResponse(response) {
    response.data.dashboards.forEach((dashboard) => {
        var _a;
        dashboard.slug = kebabCase(dashboard.title);
        dashboard.icon = (_a = dashboardIcons[dashboard.slug]) !== null && _a !== void 0 ? _a : 'chart-bar';
    });
    return response;
}
/**
 * Returns the transformed filters response.
 *
 * @param response The raw response from the filters endpoint.
 */
export function transformReadFiltersResponse(response) {
    response.data.filters.forEach((filter) => {
        filter.values = filter.values.filter((item) => item.label);
    });
    return response;
}
/**
 * Returns the transformed instruments response.
 *
 * @param response The raw response from the instruments endpoint.
 */
export function transformReadInstrumentsResponse(response, meta) {
    var _a, _b, _c;
    response.meta = (_a = response.meta) !== null && _a !== void 0 ? _a : {};
    response.meta.request_id = (_c = (_b = meta === null || meta === void 0 ? void 0 : meta.response) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c.get('X-Dixa-Rid');
    return response;
}
